import React from 'react';
import {permissionObj} from '../../../Helpers/permission';
import AddDeviceModal from './Modal/AddDeviceModal';
import DeviceLogModal from '../Devices/Modals/DeviceLogModal';
import DeleteModal from '../../Modals/DeleteModal';
import Subtitle from "../../../components/Header/Subtitle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import CustomTable from "../../../components/table/CustomTable";
import {DevicesTotalAccessTable} from "./Funtionality/DevicesTotalAccessTable";
import {TotalAccessMainApp} from "./Funtionality/TotalAccessMainApp";
import {AddIcon, TrashOutlineIcon} from '../../../components/buttons/IconButtons';

/**
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @component
 * @param {Object} props - Component properties.
 * @param {Object} props.item - Data object containing device information.
 * @returns {JSX.Element} The rendered TotalAccessService component.
 */

const TotalAccessService = ({item, setModified}) => {

    const {
        t,
        DEV,
        permission,
        setShowLogModal,
        setModalShow,
        setDeleteDeviceShow,
        modalShow,
        showLogModal,
        deleteDeviceShow,
        handleRemoveDevices
    } = TotalAccessMainApp({setModified})

    const {
        getActionsButtons,
        tableId1,
        searchId1,
        thead1,
        tbody1,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        logDevice,
        handleDeleteAll,
        handleCheckboxChange
    } = DevicesTotalAccessTable({
        data: item?.devices,
        zone: item,
        t, permission, DEV, setShowLogModal
    })

    return (
        <div className={"mt-4"}>
            <Subtitle name={'devices'}>
                { ( DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE_DEVICES)) && (
                    <ButtonAction
                        id='btn_tadv_add'
                        name='add_new_devices'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setModalShow(true);
                        }}
                        splitName={false}
                    />
                )}
                {(DEV || (permission?.includes(permissionObj?.WEB_ZONE_DELETE_DEVICES))) && (
                    <ButtonAction
                        id='btn_cp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteDeviceShow(true);
                        }}
                    />
                )}
            </Subtitle>

            <CustomTable tableId={tableId1}
                         searchId={searchId1}
                         thead={thead1}
                         tbody={tbody1}
                         checkbox={DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE_DEVICES)}
                         columnActions={true}
                         withoutHeight={true}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
            />

            {modalShow &&
                <AddDeviceModal
                    title={t('add')}
                    check='true'
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    item={item}
                    onAdded={() => setModified(true)}
                />
            }

            {showLogModal &&
                <DeviceLogModal
                    show={showLogModal}
                    onHide={() => setShowLogModal(false)}
                    data={logDevice}
                />
            }
            {deleteDeviceShow && (
                <DeleteModal
                    show={deleteDeviceShow}
                    onHide={() => setDeleteDeviceShow(false)}
                    onClickFn={() => handleRemoveDevices(selectedList)}
                    isReset={setSelectedList}
                    isAllReset={setIsAllChecked}
                    data={selectedList}
                    title_modal={"delete_devices"}
                    description={'are_you_sure_you_want_to_remove'}
                    element_modal={"device_s"}
                />
            )}
        </div>
    );
};

export default TotalAccessService;
